/**
 * /agents holds both kinds of agent. A saved analysis (a playbook) is
 * addressed by its id, always a UUID; a workspace agent by its kind, a word —
 * /agents/rocco. So one address says which it is, with nothing to look up.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isPlaybookId(value: string | undefined): boolean {
  return Boolean(value && UUID.test(value));
}
